import config from '../config.json';

export function primaryApi() {
	return config[process.env.REACT_APP_STAGE].api.primary;
}

// @TODO: Remove, api returns fully qualified paths
// export function assetsGeneralEndpoint() {
// 	return config[process.env.REACT_APP_STAGE].assetsEndpoint.general;
// }

export function freebiesApi() {
	return config[process.env.REACT_APP_STAGE].api.freebies;
}
